import { Directive } from '@angular/core';

@Directive({
  selector: '[entityListItem]',
})
export class EntityListItemDirective {}
